import { Box, Typography } from "@mui/material"
import dayjs from "dayjs"
import { ClientFragment } from "../../generated/graphql"
import {
  getMoodChartIndexDate,
  getReportedMoodDays,
} from "../../utils/moodChart"
import MoodTrendSeriesChart from "./charts/MoodTrendSeriesChart"

/**
 * Client Detail Summary mood trends: Cravings and Enjoyment side by side.
 */
export default function LoopMoodTrends({
  data,
  weekOffset = 0,
}: {
  data: ClientFragment["mood_measurements"]
  weekOffset?: number
}) {
  const chartIndexDate = getMoodChartIndexDate(weekOffset)
  const weekDays = getReportedMoodDays(chartIndexDate, 7, data)
  const rangeStart = weekDays[0]?.date ?? dayjs().subtract(7, "day")
  const rangeEnd =
    weekDays[weekDays.length - 1]?.date ?? dayjs().subtract(1, "day")
  const dateRangeLabel = `${rangeStart.format("MMM D")} – ${rangeEnd.format(
    "MMM D"
  )}`

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1.5 }}>
        <Typography
          variant="body2"
          sx={(theme) => ({
            fontSize: 12,
            color: theme.palette.vira?.muted ?? theme.palette.text.secondary,
          })}
        >
          {dateRangeLabel}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
          "@media (min-width:900px)": {
            flexDirection: "row",
            alignItems: "stretch",
          },
        }}
      >
        <Box sx={{ flex: "1 1 0", minWidth: 0, maxWidth: "100%" }}>
          <MoodTrendSeriesChart
            data={data}
            series="cravings"
            title="Cravings"
            scaleLegend="1 not at all → 5 extreme"
            trendMessage="cravings score this week"
            weekOffset={weekOffset}
          />
        </Box>
        <Box sx={{ flex: "1 1 0", minWidth: 0, maxWidth: "100%" }}>
          <MoodTrendSeriesChart
            data={data}
            series="enjoyment"
            title="Enjoyment"
            scaleLegend="1 not at all → 5 a great deal"
            trendMessage="enjoyment score this week"
            weekOffset={weekOffset}
          />
        </Box>
      </Box>
    </Box>
  )
}
